import type { OfficeRole } from '@relay-towing/api';
import { useUserCompanies } from './useUserCompanies';

/**
 * The signed-in user's office role in the selected company: Owner, Admin,
 * Dispatch or Read only, or null for someone who only drives; undefined
 * until the companies load. Driving is not a role, and what a member may do
 * is `useHasPermission`'s; this decides only which side of the app they are
 * on (the office tabs or the field tabs) and what is the owner's alone.
 */
export const useOfficeRole = (): OfficeRole | null | undefined => {
  const { companies, selectedCompanyId } = useUserCompanies();
  return companies.find(
    (membership) => membership.company.id === selectedCompanyId
  )?.officeRole;
};
